import { AfterViewInit, Component, Injector } from '@angular/core';
import { gsap } from 'gsap';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';

import { ProfileService } from '../../../profile/services/profile.service';
import AudioHelper from '../../helpers/audio.helper';
import { AudioService } from '../../services/audio.service';

@Component({
  selector: 'audio-controls',
  templateUrl: './audio-controls.component.html',
})
export class AudioControlsComponent implements AfterViewInit {

  public audioEnabled: boolean;
  public currentVolume: number;

  private volumeChangeSubject: BehaviorSubject<number>;
  private audioHelper: AudioHelper;

  /**
   * Constructor
   */
  public constructor(
    private injector: Injector,
    private profileService: ProfileService,
    private audioService: AudioService,
  ) {
    this.currentVolume = this.audioService.currentVolume;
    this.audioEnabled = this.audioService.audioEnabled;
    this.audioHelper = injector.get(AudioHelper);

    this.audioService.getAudioEnabled().subscribe({
      next: (enabled) => {
        this.audioEnabled = enabled;
      },
    });

    this.audioService.getCurrentVolume()
    .subscribe({
      next: (updatedVolume) => {
        this.currentVolume = updatedVolume;
      },
    });

    // Moved volume update here to make sure we can delay each input a little with debounceTime
    this.volumeChangeSubject = new BehaviorSubject<number>(this.currentVolume);
  }

  /**
   * Listen to volume changes after view init
   *
   * @return void
   */
  public ngAfterViewInit(): void {
    this.volumeChangeSubject
      .pipe(
        debounceTime(100),
        skip(1),
      )
      .subscribe(volume => {
        const sliderAudio: string = this.currentVolume < volume ? 'slider_up' : 'slider_down';
        this.audioService.updateCurrentVolume(volume);
        this.audioHelper.setMasterVolume(this.currentVolume);
        this.audioHelper.playAudio(sliderAudio);
      });
  }

  /**
   * Event fired when changing volume
   *
   * @param volume
   *
   * @return void
   */
  public onVolumeChange(volume): void {
    this.volumeChangeSubject.next(volume);
  }

  /**
   * Toggles audio on/off
   *
   * @return void
   */
  public toggleAudio(): void {
    this.audioService.toggleAudio();
  }

  /**
   * On enter event
   *
   * @return void
   */
  public onEnter(): void {
    gsap.to('.audio-volume-slider', { autoAlpha: 1, duration: 0.35 });
  }

  /**
   * On enter event
   *
   * @return void
   */
  public onLeave(): void {
    gsap.to('.audio-volume-slider', { autoAlpha: 0, duration: 0.35 });
  }
}
